module.exports = __webpack_public_path__ + "img/investment_grey_border.1b6e4a28.svg";